import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { FirebaseAppProvider } from 'reactfire';

import App from './App';
import Loader from './components/loader';
import reportWebVitals from './reportWebVitals';
import { firebaseConfig } from './config/firebase.config';
import 'antd/dist/antd.css'; 


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <Suspense fallback={<Loader />}>
    <FirebaseAppProvider firebaseConfig={firebaseConfig}>
      <App />
    </FirebaseAppProvider>
  </Suspense>
  </>
);

reportWebVitals();
